import * as React from 'react';
import { useRoute } from 'react-router5'; 
import NotFound from "../NotFound/NotFound";
import { RouteName } from '../../router/routes'; 
import { ErrorBoundary } from "../ErrorBoundry/ErrorBoundry";
import { Footer } from '../Footer/Footer';
import { MobileMenuDrawer } from "../MobileMenuDrawer/MobileMenuDrawer";
import { Navbar } from '../Navbar/Navbar';
import { Sidebar } from "../Sidebar/Sidebar"; 


export const Layout: React.FC<Props> = (props) => {
    const [isMobileDrawerShown, setIsMobileDrawerShown] = React.useState(false);
    const [isUserMenuShown, setIsUserMenuShown] = React.useState(false);
    const route = useRoute();
    const routeName = route?.route?.name ?? "not found";//RouteName.NotFound;

    const handleMobileMenuClick = () => {
        setIsMobileDrawerShown(!isMobileDrawerShown);
    }

    const handleUserMenuClick = () => {
        setIsUserMenuShown(!isUserMenuShown);
    }

    const hideMenus = () => {
        setIsMobileDrawerShown(false);
        setIsUserMenuShown(false);
    }

    React.useEffect(() => {
        hideMenus();
    }, [routeName])

    // const showBreadcrumbs = React.useMemo(() => {
    //     return routeName !== RouteName.Base
    //         // && routeName !== RouteName.FuelServices
    //         // && routeName !== RouteName.FuelServicesMap
    //         // && routeName !== RouteName.FuelStationList
    //         // && routeName !== RouteName.FuelByState
    // }, [routeName])

    return (
    <> 
    <MobileMenuDrawer
        isShown = {isMobileDrawerShown}
        onClickOutside = {hideMenus} 
    /> 
    <div className = "flex-wrapper">
        <Navbar 
            onMobileMenuClick = {handleMobileMenuClick}
            onUserMenuClick = {handleUserMenuClick}
        />
        <div className = "flex-wrapper__main">
            {/* <Sidebar 
            /> */}
            <div className = "view-container">
                {routeName === RouteName.NotFound
                    ? <NotFound />
                    : <> 
                        <ErrorBoundary>
                        <>{props.children}</>
                        </ErrorBoundary>
                    </>
                }
            </div>
        </div>
        <Footer />
    </div>
    </>
    )
}

interface Props {
    children: React.ReactNode;  
}